import {AfterViewInit, Component, inject, OnInit, signal} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ArbitraryRoundComponent} from "../shared/arbitrary-round/arbitrary-round.component";
import {Chart, SrmHospitalArbitrarySearchParam} from "../../../../../generated-model/model";
import {SelectZoneComponent} from "../../../../shared/components/select-zone/select-zone.component";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {SecurityService} from "../../../../security/security.service";
import {CustomUserDataResult} from "../../../../types/openid-connect-userinfo";
import {BarChartModule, Color, PieChartModule, ScaleType} from "@swimlane/ngx-charts";
import {SrmHospitalArbitraryResource} from "../../../../service/SrmHospitalArbitraryResource";
import {defaultBudgetYear} from "../../../../app.constants";
import {Router} from "@angular/router";

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ArbitraryRoundComponent,
    SelectZoneComponent,
    PieChartModule,
    BarChartModule
  ],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss'
})
export class SummaryComponent implements OnInit, AfterViewInit {

  params = signal(<SrmHospitalArbitrarySearchParam>{});
  isZone: boolean = false;
  private oidcSecurityService: OidcSecurityService = inject(OidcSecurityService);
  private router = inject(Router);
  private securityService = inject(SecurityService);
  srmHospitalArbitraryResource = inject(SrmHospitalArbitraryResource)

  dataPie: Chart[] = [];
  dataBar: Chart[] = [];
  // options color from ngx-charts
  //https://github.com/swimlane/ngx-charts/blob/master/projects/swimlane/ngx-charts/src/lib/utils/color-sets.ts
  colorBar : Color = {
    name: 'natural',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
      '#d89f59',
      '#f2dfa7',
      'rgb(197, 224, 180)',
      '#a5d7c6',
      '#d9d5c3'
    ]
  };
  colorPie : Color = {
    domain: ['rgb(197, 224, 180)', 'rgb(244, 177, 131)', 'rgb(255 ,230, 153)'],
    name: 'cool_x',
    selectable: true,
    group: ScaleType.Ordinal,
  };
  view: [700, 500];

  constructor() {
  }

  ngAfterViewInit(): void {
    this.search();
  }

  ngOnInit(): void {
    this.defaultZone()
  }

  defaultZone(){
    this.oidcSecurityService.userData$.subscribe((e: CustomUserDataResult) => {
      this.isZone = this.securityService.isAnyAuthority(e, ["zone"]);
      if (this.isZone) {
        this.params().zone = {id: e.userData?.organization?.id.padStart(2, '0')}
      }
    });
  }

  search() {
    this.srmHospitalArbitraryResource.searchHospitalArbitraryPie(this.params()).subscribe({
      next: e => {
        this.dataPie = e
      }
    })
    this.srmHospitalArbitraryResource.searchHospitalArbitraryBar(this.params()).subscribe({
      next: e => {
        this.dataBar = e
      }
    })
  }

  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

  reset() {
    this.params.set({})
    this.defaultZone()
    this.params().budgetYear = defaultBudgetYear()
  }

  downloadSummary() {
    this.srmHospitalArbitraryResource.downloadSummary(this.params())
  }

  navigate() {
    this.router.navigate([`/secure/arbitrary/new`])
  }
}
